import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { EditSubmissionRulesComponent } from './edit-submission-rules.component';
import { NgxPopupService } from '../../../shared/ngx-popups/ngx-popups/services/ngx-popup.service';
import { ConfirmationPopupComponent } from '../../../shared/popups/confirmation/confirmation-popup.component';
import { inject } from '@angular/core';

export const EditSubmissionRulesDeactivateGuard: CanDeactivateFn<EditSubmissionRulesComponent> = 
  (component: EditSubmissionRulesComponent, currentState, nextState, nextExtras): Observable<boolean> | Promise<boolean> | boolean => {
    const popupService = inject(NgxPopupService);
    if (component.isDirty && component.hasUnsavedChanges()) {
      return new Promise<boolean>((resolve) => {
        popupService.open({
          componentType: ConfirmationPopupComponent,
          cssClass: 'modal-confirmation',
          inputs: {
            question: 'UNSAVED CHANGES',
            text: 'Are you sure you want to exit this page? Any unsaved changes will be lost.',
            confirmButtonText: 'Save and Exit',
            cancelButtonText: 'Exit Without Saving'
          },
          outputs: {
            callback: (approved: boolean) => {
              if (approved) {
                component.saveRulesAndExitWithCallback((saveSuccess: boolean) => {
                  if (saveSuccess) {
                    // Save was successful, allow navigation
                    resolve(true);
                    component.isDirty = false;
                  } else {
                    // Save failed, don't allow navigation (stay on current page)
                    resolve(false);
                  }
                });
              } else {
                // Exit without saving, allow navigation
                resolve(true);
                component.isDirty = false;
              }
            }
          },
        });
      });
    }
    
    // No unsaved changes, allow navigation
    return true;
  };
